export const ReadBestLoyaltyBenefitsTrackersV1 = 'ReadBestLoyaltyBenefitsTrackers.v1';

// TODO:
// Temporary hardcoded Walmart benefit IDs. Need discuss a better,
// scalable approach for identifying Walmart benefits/trackers (e.g., RLB API).
// This is a temporary solution.
export const WALMART_BENEFIT_IDS = [
  '59eb0cee-ce1d-47fb-86aa-1fa2a94dd92a',
  '75897475-46dc-49b7-8fa1-261c6a4d5da1',
];

// The airline-bonus benefit shares a sorBenefitId with another benefit.
// It must be excluded from tracker lookups so the correct benefit is resolved.
export const AIRLINE_BONUS_BENEFIT_NAME = 'airline-bonus';
